export const CATEGORY = 'blue';
export const SELLER = 'yellow';
export const BRAND = 'green-light';
